import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody } from 'reactstrap';
import { clearModal } from '@shoflo/studio-redux/actions';
import { MEDIA, VIDEO_FILE, getFileSourceType } from '@shoflo/polymer';
import ModalHeader from 'components/Modal/Header';
import { MEDIA_TEMPLATES } from 'constants/ModalTypes';
import TemplateWrapper from 'containers/pages/Broadcast/Templates';
import { copyTemplate, updateSource } from 'actions/Broadcast';
import { selectLastMediaSource } from 'selectors/broadcastSourcesSelector';

const OverlaysTemplates = () => {
  const isOpen = useSelector(
    ({ modal }) => modal && modal.type === MEDIA_TEMPLATES
  );
  const { order: lastMediaOrder = 0 } = useSelector(selectLastMediaSource);
  const dispatch = useDispatch();
  const clearThisModal = () => dispatch(clearModal(MEDIA_TEMPLATES));

  const { sources } = useSelector(({ broadcastSources }) => broadcastSources);

  const onSelectTemplate = template => {
    const payload = {
      title: template.name || template.key,
      order: lastMediaOrder + 1,
      value: { eventDocId: template._id, url: template.url },
      type: template.type || 'media',
      isEventTemplate: template.isEventTemplate
    };
    if (template.media) {
      const fileType = getFileSourceType(payload.title);
      if (fileType === VIDEO_FILE) {
        dispatch(
          copyTemplate({
            ...payload,
            sourceId: template.media._id
          })
        );
      } else {
        dispatch(
          updateSource(template.media._id, {
            type: fileType,
            title: template.name,
            value: payload.value
          })
        );
      }
    } else {
      if (template._id) {
        payload._id = template._id;
      }
      dispatch(
        copyTemplate({
          ...payload,
          value: template.value
        })
      );
    }
    clearThisModal();
  };

  const getMediaSources = () => {
    return sources.filter(source => source?.type === MEDIA);
  };

  return (
    <Modal
      size="xl"
      isOpen={isOpen}
      toggle={clearThisModal}
      data-testid="media-template-chooser-modal"
    >
      <ModalHeader>Add content</ModalHeader>
      <ModalBody>
        <TemplateWrapper
          mediaSources={getMediaSources()}
          title={'media'}
          onCancel={clearThisModal}
          onSelectTemplate={onSelectTemplate}
        />
      </ModalBody>
    </Modal>
  );
};

export default OverlaysTemplates;
